import { defineNuxtPlugin } from '#app/nuxt'
import { LazyCocoaDeforestation, LazyCocoaPrices, LazyCocoaProduction, LazyCocoaReality, LazyCocoaRetailers, LazyCocoaSpiking, LazyCocoaWestAfrica, LazyColumnImage, LazyColumnText, LazyColumnVideo, LazyColumnsImage, LazyColumnsMix, LazyColumnsText, LazyGlobalHeader, LazyGlobalHero, LazyHome, LazyHomeAward, LazyHomeAwards, LazyHomeCocoa, LazyHomeCompanies, LazyHomeCompaniesType, LazyHomeConsumers, LazyHomeHero, LazyHomeInsight, LazyHomeInsights, LazyHomeIssue, LazyHomeIssueArrowRight, LazyHomeIssueArrowRow, LazyHomeIssues, LazyHomeMethodology, LazyHomeNewsletter, LazyHomeQuestions, LazyHomeScorecards, LazyHomeTeam, LazyHomeVideo, LazyHomeWork, LazyInsights, LazyInsightsAgroforestry, LazyInsightsChildLabor, LazyInsightsDeforestation, LazyInsightsGender, LazyInsightsHeader, LazyInsightsHealth, LazyInsightsHero, LazyInsightsKeys, LazyInsightsLivingIncome, LazyInsightsPesticides, LazyInsightsTraceability, LazyMedia, LazyMediaGallery, LazyMediaHero, LazyMediaHighlight, LazyMediaOverview, LazyMethodology, LazyMethodologyDevelopment, LazyMethodologyIntro, LazyMethodologyParticipation, LazyMethodologyScoring, LazyMethodologySupport, LazyMethodologySurvey, LazyNewsSlider, LazyStateOfCocoa, LazyStory, LazySupply, LazySupplyDescription, LazySupplyHeader, LazySupplyHero, LazySupplyQuestions, LazyTeam, LazyTeamArea, LazyTeamEdition, LazyTeamFunding, LazyTeamHero, LazyTeamPartners, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["CocoaDeforestation", LazyCocoaDeforestation],
["CocoaPrices", LazyCocoaPrices],
["CocoaProduction", LazyCocoaProduction],
["CocoaReality", LazyCocoaReality],
["CocoaRetailers", LazyCocoaRetailers],
["CocoaSpiking", LazyCocoaSpiking],
["CocoaWestAfrica", LazyCocoaWestAfrica],
["ColumnImage", LazyColumnImage],
["ColumnText", LazyColumnText],
["ColumnVideo", LazyColumnVideo],
["ColumnsImage", LazyColumnsImage],
["ColumnsMix", LazyColumnsMix],
["ColumnsText", LazyColumnsText],
["GlobalHeader", LazyGlobalHeader],
["GlobalHero", LazyGlobalHero],
["Home", LazyHome],
["HomeAward", LazyHomeAward],
["HomeAwards", LazyHomeAwards],
["HomeCocoa", LazyHomeCocoa],
["HomeCompanies", LazyHomeCompanies],
["HomeCompaniesType", LazyHomeCompaniesType],
["HomeConsumers", LazyHomeConsumers],
["HomeHero", LazyHomeHero],
["HomeInsight", LazyHomeInsight],
["HomeInsights", LazyHomeInsights],
["HomeIssue", LazyHomeIssue],
["HomeIssueArrowRight", LazyHomeIssueArrowRight],
["HomeIssueArrowRow", LazyHomeIssueArrowRow],
["HomeIssues", LazyHomeIssues],
["HomeMethodology", LazyHomeMethodology],
["HomeNewsletter", LazyHomeNewsletter],
["HomeQuestions", LazyHomeQuestions],
["HomeScorecards", LazyHomeScorecards],
["HomeTeam", LazyHomeTeam],
["HomeVideo", LazyHomeVideo],
["HomeWork", LazyHomeWork],
["Insights", LazyInsights],
["InsightsAgroforestry", LazyInsightsAgroforestry],
["InsightsChildLabor", LazyInsightsChildLabor],
["InsightsDeforestation", LazyInsightsDeforestation],
["InsightsGender", LazyInsightsGender],
["InsightsHeader", LazyInsightsHeader],
["InsightsHealth", LazyInsightsHealth],
["InsightsHero", LazyInsightsHero],
["InsightsKeys", LazyInsightsKeys],
["InsightsLivingIncome", LazyInsightsLivingIncome],
["InsightsPesticides", LazyInsightsPesticides],
["InsightsTraceability", LazyInsightsTraceability],
["Media", LazyMedia],
["MediaGallery", LazyMediaGallery],
["MediaHero", LazyMediaHero],
["MediaHighlight", LazyMediaHighlight],
["MediaOverview", LazyMediaOverview],
["Methodology", LazyMethodology],
["MethodologyDevelopment", LazyMethodologyDevelopment],
["MethodologyIntro", LazyMethodologyIntro],
["MethodologyParticipation", LazyMethodologyParticipation],
["MethodologyScoring", LazyMethodologyScoring],
["MethodologySupport", LazyMethodologySupport],
["MethodologySurvey", LazyMethodologySurvey],
["NewsSlider", LazyNewsSlider],
["StateOfCocoa", LazyStateOfCocoa],
["Story", LazyStory],
["Supply", LazySupply],
["SupplyDescription", LazySupplyDescription],
["SupplyHeader", LazySupplyHeader],
["SupplyHero", LazySupplyHero],
["SupplyQuestions", LazySupplyQuestions],
["Team", LazyTeam],
["TeamArea", LazyTeamArea],
["TeamEdition", LazyTeamEdition],
["TeamFunding", LazyTeamFunding],
["TeamHero", LazyTeamHero],
["TeamPartners", LazyTeamPartners],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
